import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { checkedState, unCheckedState, deleteAccountEmployeeTimeEntryAsync, Edit, checkedAllState, unCheckedAllState, getTimeEntryArchiveForDatatableAsync,updateSorting } from './TimeEntryArchiveSlice';
import CustomPagination from "../../../common/Pagination";
import OffCanvas from '../../../common/OffCanvas';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { TimeEntryArchiveForm } from './TimeEntryArchiveForm';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
const itemClass = 'ms-1 ms-lg-0';
const TimeEntryArchiveItem = (props: any) => {
    const { onhandleFormOnClickEvent, offCanvasObject, t, onopenModal, IsEdit, IsDelete } = props;

    const dispatch = useAppDispatch();
    const { timeEntryArchiveList, isReload, currentPage, pageSize,sortColumn,sortOrder, totalItems, start, search, recordsFiltered, timeEntryArchiveCheckedIds, selectedRecord,
        optionClientNameValue, optionClientNameText, optionEmployeeNameValue, optionEmployeeNameText, optionProjectValue, optionProjectText,
        optionProjectTaskValue, optionProjectTaskText, optionApprovedValue, optionApprovedText, startDate, endDate
    } = useAppSelector((state) => state.timeEntryArchive);    
    const { cultureInfoName, dateInsertionFormat, decimalPlaces, decimalFormat } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    // var isMobileView = ($("body").width() <= 500 ? true : false);
    // var isTabletView = ($("body").width() <= 768 ? true : false);
    const isMobileView = window.innerWidth <= 500 ? true : false;
    const isTabletView = window.innerWidth <= 768 ? true : false;
    // var shortDateFormat = '<%= LocaleUtilitiesBLL.GetBaseCultureInfo.DateTimeFormat.ShortDatePattern %>';
    // var isDecimalFormat = ('<%= DBUtilities.IsTimeEntryHoursFormat%>' == "Decimal" ? true : false);
    // const isDecimalFormat = false
    // <%= LocaleUtilitiesBLL.ShowPercentageInTimesheet%>
    const ShowPercentageInTimesheet = false

    useEffect(() => {
        if (isReload) {

            let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
            ${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
            dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: currentPage, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: " " }));
        }
    }, [isReload]);
    useEffect(() => {
        let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
        ${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: currentPage, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: " " }));
    }, [dispatch]);


    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId));

        } else {
            dispatch(unCheckedState(rowId));

        }
    };



    const CheckStatusForTimeEntryArchive = (approved: boolean, rejected: boolean, submitted: boolean) => {
        if (approved) {
            return <span className="badge badge-light-success">
                {/* {t('Approved')} */}
                {getValueFromResource('Approved',dispatch, t)}
</span>;
        } else if (rejected) {
            return <span className="badge badge-light-danger">
                 {/* {t('Rejected')} */}
                 {getValueFromResource('Rejected',dispatch, t)}
                 </span>;
        } else if (submitted) {
            return <span className="badge badge-light-primary">
                {/* {t('Submitted')} */}
                {getValueFromResource('Submitted',dispatch, t)}
</span>;
        } else if (rejected === false && submitted === false && approved === false) {
            return <span className="badge badge-light-warning">
                {/* {t('Not Submitted')} */}
                {getValueFromResource('Not Submitted',dispatch, t)}
                </span>;
        } else if (submitted && approved === false) {
            return <span className="badge badge-light-warning">
                {/* {t('Not Submitted')} */}
                {getValueFromResource('Not Submitted',dispatch, t)}
                </span>;
        }
        else {
            return <span className="badge badge-light-warning">
                {/* {t('Not Submitted')} */}
                {getValueFromResource('Not Submitted',dispatch, t)}

                </span>;
        }
    };
    const onEditClick = (timeEntryArchiveObj: any) => {
        dispatch(Edit(timeEntryArchiveObj))
        // onhandleFormOnClickEvent(offCanvasObject);
        onopenModal();
    }
    const onDeleteClick = (timeEntryArchiveObj: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountEmployeeTimeEntryAsync(timeEntryArchiveObj))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Time Entry(s) Deleted Succesfully", 'Success', "success", "toast-top-right")
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
        // const result = window.confirm('Are you sure you want to delete?');
        // if (result) {
        //     dispatch(deleteAccountEmployeeTimeEntryAsync(timeEntryArchiveObj))
        //     .unwrap()
        //     .then((originalPromiseResult) => {

        //     })
        //     .catch((rejectedValueOrSerializedError) => {

        //     })
        // } 
    }
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const handlePageChange = (pageNumber: any) => {
        const start = (pageNumber - 1) * pageSize;
        let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
            ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        //${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
        //onhandlePageChange(pageNumber);
    };
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            {timeEntryArchiveList.length === 0 ?
                <div className=''><p className='noDataFound mt-2'>
                     {/* {t('No Record Found')}  */}
                     {getValueFromResource('No Record Found',dispatch, t)}
                     </p>
                </div> :
                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                        <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={timeEntryArchiveList.every((item) => item.isSelected === 0) ? false : (timeEntryArchiveList.every((item) => item.isSelected === 1 ? true : false))}
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
}
                        <th style={{width:'25%'}}>
                            {/* {t('Employee Name')}   */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                                {sortColumn === 'EmployeeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'15%'}}>
                                    {/* {t('Project/Task')} */}
                                    {getValueFromResource('Project/Task',dispatch, t)}
                                  {sortColumn === 'TaskName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'15%'}}>
                                    {/* {t('Date')} */}
                                    {getValueFromResource('Date',dispatch, t)}
                                  {sortColumn === 'TimeEntryDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TimeEntryDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TimeEntryDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TimeEntryDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TimeEntryDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'15%'}}>
                                    {/* {t('Total Time')}  */}
                                    {getValueFromResource('Total Time',dispatch, t)}
                                 {sortColumn === 'TotalTime' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalTime") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalTime") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalTime") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalTime") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                            {ShowPercentageInTimesheet ? (
                              <th style={{width:'15%'}}>
                                {/* {t('Percentage')} */}
                                {getValueFromResource('Percentage',dispatch, t)}
                                  {sortColumn === 'AccountLocation' ?
                                    sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountLocation") }}>
                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountLocation") }}>
                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                    </span>
                                    :
                                    // hoveredColumn === 0 &&
                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountLocation") }}>
                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountLocation") }}>
                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                    </>}</th>
                            ) : null}
                           <th style={{width:'15%'}}>
                            {/* {t('Billing Rate')}   */}
                            {getValueFromResource('Billing Rate',dispatch, t)}
                                {sortColumn === 'BillingRate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingRate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingRate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingRate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingRate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'15%'}}>
                                    {/* {t('Status')} */}
                                    {getValueFromResource('Status',dispatch, t)}
                                  {sortColumn === 'Submitted' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Submitted") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Submitted") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Submitted") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Submitted") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                            <th className='w-10 text-center '></th>
                        </tr>
                    </thead>
                    <tbody>
                        {timeEntryArchiveList.length > 0 && timeEntryArchiveList.map((timeEntryArchiveObj: any, i: any) => (
                            <tr key={i}>
                                 {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >

                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={timeEntryArchiveObj.isSelected == 0 ? false : true}
                                            onChange={e => handleCheckboxChange(e, timeEntryArchiveObj.AccountEmployeeTimeEntryId)}
                                        />
                                    </div>
                                </td>
}
                                <td>
                                    <span className="d-block">
                                        {timeEntryArchiveObj.EmployeeName}
                                    </span>
                                </td>
                                <td>
                                    <span className="d-block">
                                        {timeEntryArchiveObj.ProjectName != null ? timeEntryArchiveObj.ProjectName : 'None'}
                                        {isMobileView ? ' / ' : <br></br>}
                                        {timeEntryArchiveObj.TaskName}
                                    </span>
                                </td>
                                {/* <td>
                                    <span className="d-block align-middle">
                                        <i className="bi bi-calendar fs-5 me-2"></i>
                                        {moment(timeEntryArchiveObj.TimeEntryDate).format('M/D/YYYY')}
                                    </span>
                                </td> */}
                                <td>
                                    <span className="d-block">
                                        <i className="bi bi-calendar fs-5 me-2 align-middle" 
                                        //style={{ verticalAlign: 'middle' }}
                                        ></i>
                                        {/* {moment.parseZone(timeEntryArchiveObj.TimeEntryDate).format('DD MMM yy')} */}
                                        {formatDateWithDateAndMonthName(timeEntryArchiveObj.TimeEntryDate, cultureInfoName.toString())}
                                    </span>

                                </td>
                                <td>
                                    <div 
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content={getValueFromResource('Start Time',dispatch, t)  + ": " + timeEntryArchiveObj.StartTime + "\n; " + getValueFromResource('End Time',dispatch, t) + ": " + timeEntryArchiveObj.EndTime}
                                        data-tooltip-place="top"
                                        className="badge badge-light fw-bolder">
                                        <span className="d-block">
                                            {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(timeEntryArchiveObj.Hours ), 2) : timeEntryArchiveObj.TotalTime}                    
                                        </span>
                                    </div>
                                </td>
                                {ShowPercentageInTimesheet ? (
                                    <td className="text-end">
                                        <div className="d-flex flex-column w-100 me-2">
                                            <div className="d-flex flex-stack mb-2">
                                                <span className="d-block">{timeEntryArchiveObj.Percentage}%</span>
                                            </div>
                                            <div className="progress h-6px w-100">
                                                <div className="progress-bar bg-success" role="progressbar" style={{ width: timeEntryArchiveObj.Percentage + '%' }}>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                ) : null}
                                <td>
                                    <span className="d-block">
                                        {/* {timeEntryArchiveObj.BillingRate} */}
                                        {FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeEntryArchiveObj.BillingRate, decimalPlaces)}
                                    </span>
                                </td>

                                <td>
                                    {CheckStatusForTimeEntryArchive(timeEntryArchiveObj.Approved, timeEntryArchiveObj.Rejected, timeEntryArchiveObj.Submitted)}
                                </td>
                                <td className='text-center' >
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                {IsEdit &&
                                                    <>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => { onEditClick(timeEntryArchiveObj) }}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                                {IsDelete && IsEdit &&
                                                    <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                }
                                                {IsDelete &&
                                                    <>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => { onDeleteClick(timeEntryArchiveObj) }}
                                                            >
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {/* {`${t('Delete')}`} */}
                                                                    {getValueFromResource('Delete',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            }
            {/* <div>
                {(timeEntryArchiveList.length > 0 && pageSize < totalItems) ? (
                    <CustomPagination
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        pageSize={pageSize}
                        totalItems={totalItems}
                        start={start}
                        recordsFiltered={recordsFiltered}
                    >

                    </CustomPagination>
                ) : null}
            </div> */}
        </>
    )
}

export default TimeEntryArchiveItem
